function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  width: 20,
  height: 20,
  fill: "white"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M10.8 2V8.4H17.2C17.2 4.864 14.336 2 10.8 2ZM15.856 13.112C16.696 12.032 17.2 10.672 17.2 9.2H5.552L4.792 7.6H2V9.2H3.776C3.776 9.2 5.288 12.456 5.472 12.736C4.592 13.208 4 14.136 4 15.2C4 16.744 5.256 18 6.8 18C8.208 18 9.376 16.96 9.568 15.6H11.232C11.424 16.96 12.592 18 14 18C15.544 18 16.8 16.744 16.8 15.2C16.8 14.368 16.432 13.624 15.856 13.112ZM6.8 16.4C6.136 16.4 5.6 15.864 5.6 15.2C5.6 14.536 6.136 14 6.8 14C7.464 14 8 14.536 8 15.2C8 15.864 7.464 16.4 6.8 16.4ZM14 16.4C13.336 16.4 12.8 15.864 12.8 15.2C12.8 14.536 13.336 14 14 14C14.664 14 15.2 14.536 15.2 15.2C15.2 15.864 14.664 16.4 14 16.4Z",
  fill: "#E24443"
});

var SvgBaby = function SvgBaby(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBaby, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/baby.ed58241b.svg";
export { ForwardRef as ReactComponent };